import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
export function MaisFiltros({ ativos, resumo = [], children, avancados, rotulo = "Mais filtros", }) {
    const [aberto, setAberto] = useState(false);
    const [verAvancados, setVerAvancados] = useState(false);
    const temAtivo = ativos > 0;
    return (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 10, width: "100%" }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }, children: [_jsxs("button", { type: "button", onClick: () => setAberto((v) => !v), "aria-expanded": aberto, style: temAtivo ? btnAtivo : btn, children: [aberto ? "▾" : "▸", " ", rotulo, temAtivo ? ` (${ativos})` : ""] }), !aberto && resumo.length > 0 ? (_jsx("div", { style: { display: "flex", gap: 6, flexWrap: "wrap" }, children: resumo.map((r) => (_jsxs("button", { type: "button", onClick: r.limpar, title: `Remover filtro: ${r.rotulo}`, style: chip, children: [_jsxs("span", { style: { color: "var(--text-muted)" }, children: [r.rotulo, ":"] }), _jsx("span", { style: { fontWeight: 700 }, children: r.valor ?? "ativo" }), _jsx("span", { "aria-hidden": true, style: { opacity: 0.7 }, children: "\u2715" })] }, r.rotulo))) })) : null] }), aberto ? (_jsxs("div", { style: {
                    display: "flex", flexDirection: "column", gap: 14,
                    padding: 14, borderRadius: 10,
                    border: "1px solid var(--border)", background: "var(--bg-elev-1)",
                }, children: [children, avancados ? (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [_jsxs("button", { type: "button", onClick: () => setVerAvancados((v) => !v), "aria-expanded": verAvancados, style: {
                                    alignSelf: "flex-start", background: "transparent", border: "none",
                                    color: "var(--text-muted)", cursor: "pointer", fontSize: 12,
                                    fontWeight: 700, letterSpacing: ".05em", padding: 0,
                                }, children: [verAvancados ? "▾" : "▸", " AVAN\u00C7ADOS"] }), verAvancados ? _jsx("div", { style: { display: "flex", flexDirection: "column", gap: 14 }, children: avancados }) : null] })) : null] })) : null] }));
}
/**
 * Um grupo de dimensoes com titulo.
 *
 * Agrupar por SENTIDO (entidade, periodo, valores, qualidade/seguranca) e nao
 * por tipo de controle: o operador procura "banco", nao "o select".
 */
export function MaisFiltrosGrupo({ titulo, children }) {
    return (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: 8 }, children: [_jsx("div", { style: {
                    fontSize: 11, fontWeight: 700, letterSpacing: ".06em",
                    color: "var(--text-dim)", textTransform: "uppercase",
                }, children: titulo }), _jsx("div", { style: { display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }, children: children })] }));
}
const btn = {
    padding: "8px 14px",
    borderRadius: 8,
    border: "1px solid var(--border-strong)",
    background: "transparent",
    color: "var(--text)",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: "0.05em",
    cursor: "pointer",
    whiteSpace: "nowrap",
};
/** Mesmo realce de "ativo" do `FilterBar`, `FilterChips` e `FiltroPill`. */
const btnAtivo = {
    ...btn,
    border: "1px solid var(--accent)",
    background: "color-mix(in srgb, var(--accent) 16%, transparent)",
    fontWeight: 700,
};
const chip = {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 10px",
    borderRadius: 999,
    border: "1px solid var(--accent)",
    background: "color-mix(in srgb, var(--accent) 12%, transparent)",
    color: "var(--text)",
    fontSize: 12,
    cursor: "pointer",
};
//# sourceMappingURL=MaisFiltros.js.map